import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-thanks',
    templateUrl: './thanks.component.html',
    styleUrls: ['./thanks.component.scss'],
    standalone: false
})
export class ThanksComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
